<template>
  <!-----Tabla---->
  <v-simple-table>
    <template v-slot:default>
      <!----Cabecera de la tabla---->
      <thead>
        <tr>
          <th class="text-center">Id_Proveedor</th>
          <th class="text-center">Proveedor</th>
          <th class= "text-center">Telefono Proveedor</th>
          <th class="text-center">Tipo Material</th>
          <th class="text-center">Cantidad</th>          
        </tr>
      </thead>
      <!-----Cuerpo de la tabla----->
      <tbody>
        <tr v-for="item in materiales" :key="item._id">
          <td>{{item.proveedor._id}}</td>
          <td>{{item.proveedor.razon_social}}</td>
          <td>{{item.proveedor.telefono}}</td>
          <td>{{item.tipo_material }}</td>
          <td>{{item.cantidad }}</td>
                  
          <!----Columna de acciones--->
          <td>
            <v-btn class="ma-2" outlined color="indigo" v-on:click="actualizar(item)">
              Actualizar
            </v-btn>
            <v-btn class="ma-2" outlined color="error" v-on:click="eliminar(item._id)"><!---@click-->
              Eliminar
            </v-btn>
            </td>
            <v-btn class="ma-2" outlined color="error" v-on:click="consultarProveedores()"><!---@click-->
              Consultar Proveedores
            </v-btn>
          </tr>
          </tbody>
  

    </template>
  </v-simple-table>
  
</template>

<script>
import store from "../store/index.js";

export default {
  methods:{
    eliminar(id){
      console.log("Eliminar-> ", id);
      let obj = { id };
      store.dispatch('eliminarMaterial', obj).then(()=>{
        //realiza solicitud get al backend
        store.dispatch("cargarMateriales");
      });
    },
    consultarProveedores(){
      this.$router.push('/consulta');
    },
    actualizar(objMaterial){
      console.log("Estoy en el hijo-> ", objMaterial);
      //Emitir al padre el objeto persona
      this.$emit('objMaterial', objMaterial);
    }
  },
  created: () => {
    //realiza solicitud get al backend
    store.dispatch("cargarMateriales");
    store.dispatch("cargarProveedores");
  },
  //Propiedades computadas
  computed: {
    materiales: () => {
      return store.state.materiales;
    },
    proveedores: () => {
      return store.state.proveedores;
    },
  },
};
</script>

<style>
</style>
